import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { RouteHelpers } from '@/mixins';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const ScriveEditSignerRole = () =>
  import(
    /* webpackChunkName: "ScriveEditSignerRole" */
    '@/views/configuration/scrive/ScriveEditSignerRole.vue'
  );

const ScriveAddSignerRole = () =>
  import(
    /* webpackChunkName: "ScriveAddSignerRole" */
    '@/views/configuration/scrive/ScriveAddSignerRole.vue'
  );

const ScriveSignerRoleManagement = () =>
  import(
    /* webpackChunkName: "ScriveSignerRoleManagement" */
    '@/views/configuration/scrive/ScriveSignerRoleManagement.vue'
  );

const meta = {
  layout: 'TreeView',
  treePath: 'scrivesignerroles',
  treeViewKey: TreeViewConstants.Keys.Configuration,
  title: 'Scrive Signer Roles'
};

export const SignerRoleRoutes = [
  {
    ...Configuration.Scrive.SignerRole.Management,
    components: {
      default: ScriveSignerRoleManagement,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.Scrive.SignerRole.Edit,
    components: {
      default: ScriveEditSignerRole,
      treeView: ConfigurationTreeView
    },
    meta,
    beforeEnter: (to: any, from: any, next: any) => {
      RouteHelpers.setErrorPageRedirect(Configuration.Scrive.SignerRole.Management.name);
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['documentTypeId', 'id']);
    }
  },
  {
    ...Configuration.Scrive.SignerRole.Add,
    components: {
      default: ScriveAddSignerRole,
      treeView: ConfigurationTreeView
    },
    meta,
    beforeEnter: (to: any, from: any, next: any) => {
      RouteHelpers.setErrorPageRedirect(Configuration.Scrive.SignerRole.Management.name);
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['documentTypeId']);
    }
  }
];
